import { useEffect, useState, useRef, useMemo } from "react";
import cmpInstance from "../consentManagement/CMPService";
import prebidInstance from "./prebidSetup"; 

const usePrebid = () => {
  const [isPrebidReady, setIsPrebidReady] = useState(false);
  const [adUnitsRegistered, setAdUnitsRegistered] = useState(false);
  const [isGDPR, setIsGDPR] = useState(cmpInstance.isGDPR); 
  const [showBanner, setShowBanner] = useState(cmpInstance.showBanner);
  const hasSubscribedToAdUnits = useRef(false);

  useEffect(() => {

    const unsubscribe = cmpInstance.subscribeToConsentChanges(updatedConsent => {
      //console.log("[usePrebid] Consent updated:", updatedConsent);
      setIsGDPR(updatedConsent.isGDPR);
      setShowBanner(updatedConsent.showBanner);
    });

    return () => unsubscribe();
  }, []);

    useEffect(() => {
      if (!prebidInstance.initialized) return;

      setIsPrebidReady(true);
    }, [prebidInstance.initialized]);

  //2. Subscribe to Ad Units Once Prebid.js is Ready
  useEffect(() => {
    if (hasSubscribedToAdUnits.current) return;

    hasSubscribedToAdUnits.current = true;
    
    const unsubscribe = prebidInstance.subscribeToAdUnits((registered) => {
      //console.log("[usePrebid] Ad units registered:", registered);
      setAdUnitsRegistered(registered);
    });

    return () => {
      unsubscribe();
    };
  }, [isPrebidReady]);

  //4. Memoize adUnitsRegistered to prevent unnecessary re-renders
  const memoizedAdUnitsRegistered = useMemo(() => {

    return adUnitsRegistered;
  }, [adUnitsRegistered]);

  return {
    isPrebidReady,
    adUnitsRegistered: memoizedAdUnitsRegistered,
    isGDPR,
    showBanner
  };
};

export default usePrebid;
